import { create } from "zustand";
import { persist } from "zustand/middleware";

function encode(value) {
  return btoa(unescape(encodeURIComponent(JSON.stringify(value))));
}

function decode(value) {
  return JSON.parse(decodeURIComponent(escape(atob(value))));
}

const useCheckoutStore = create(
  persist(
    (set) => ({
      shopId: null,
      cartItems: [],
      checkoutData: {
        method: "",
        pickupTimeType: "asap",
        scheduledPickup: "",
        contact: {
          firstName: "",
          lastName: "",
          phone: "",
        },
        address: {
          street: "",
          city: "",
          postcode: "",
          nip: "",
          accessCode: "",
          flat: "",
          floor: "",
          company: "",
        },
        notes: "",
        payment: "",
      },

      setShopId: (id) => set({ shopId: id }),

      setCartItems: (items) => set({ cartItems: items }),

      addItem: (item) =>
        set((state) => {
          const existing = state.cartItems.find((i) => i.cartKey === item.cartKey);
          if (existing) {
            return {
              cartItems: state.cartItems.map((i) =>
                i.cartKey === item.cartKey
                  ? { ...i, quantity: i.quantity + item.quantity }
                  : i
              ),
            };
          } else {
            return {
              cartItems: [...state.cartItems, item],
            };
          }
        }),

      updateCheckoutData: (data) =>
        set((state) => ({
          checkoutData: {
            ...state.checkoutData,
            ...data,
          },
        })),

      resetCheckout: () =>
        set({
          cartItems: [],
          checkoutData: {
            method: "",
            pickupTimeType: "asap",
            scheduledPickup: "",
            contact: {
              firstName: "",
              lastName: "",
              phone: "",
            },
            address: {
              street: "",
              city: "",
              postcode: "",
              nip: "",
              accessCode: "",
              flat: "",
              floor: "",
              company: "",
            },
            notes: "",
            payment: "",
          },
        }),
    }),
    {
      name: "checkout-storage",
      serialize: (state) => encode(state),
      deserialize: (str) => decode(str),
    }
  )
);

export default useCheckoutStore;
